import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { setSelectInsuranceTypeModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import memberProfileService from 'bff/services/memberProfileService';
import commonService from 'utils/commonService';
import sweetAlertService from 'utils/sweetAlertService';
import { CodeId } from 'constants/enums/codeId.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import { withRouter } from 'react-router-dom';
import { NationalType } from 'constants/enums/nationalType.enum';
import { InsType } from 'constants/enums/insType.enum';

const SelectInsuranceTypeModal: React.FC<IProps> = (props) => {
  // console.log(props);

  /**
   * @description 建立欄位內容集合
   * @param startIndex 迴圈起始 index
   * @param 顯示欄位數
   */
  const handleCreateTbody = (vehicleLmt:string[][]) => {
    const tbody = new Array(0);

    for (let i = 0; i < vehicleLmt.length; i += 1) {
      const child = handleCreateLmtBody(vehicleLmt[i], i);
      tbody.push(child);
    }

    return tbody;
  };

  /**
   * @description 建立欄位內容
   */
  const handleCreateLmtBody = (content:string[], index:number) => {
    if (content.length === 0) return;

    const childs = new Array(0);
    if (index === 0) {
      _.forEach(content, (str:string, index:number) => {
        childs.push(<th key={index} className="element__table-horizon-x-title">{str}</th>);
      });
    } else {
      _.forEach(content, (str:string, index:number) => {
        if (index === 0) {
          childs.push(<th key={index} className="element__table-horizon-y-title">{str}</th>);
        } else {
          let childVal:any = str;
          if (str && str.toUpperCase() === 'V') childVal = <i className="element__tick-icon" />;
          childs.push(<td key={index}>{childVal}</td>);
        }
      });
    }

    return (
      <tr key={index}>
        {childs}
      </tr>
    );
  };

  /**
   * @description 關閉 Modal
  */
  const handleClose = () => {
    props.setSelectInsuranceTypeModalVisible(false);
  };

  /**
   * @description 我要投保-網投項目
  */
  const handleValidLogin = async () => {
    const nationalityType = props.modal.selectInsuranceTypeModalState.nationalityType;

    // 若已登入，直接關閉 Modal
    if (storageService.getItem(storageKeys.MemberId) && nationalityType !== NationalType.Legal) {
      handleClose();

      return;
    }

    if (nationalityType === NationalType.Legal) {
      sweetAlertService.modal({
        html: '法人不可選擇網路投保',
        showCloseButton: true
      });

      return;
    }

    const memberId = props.modal.selectInsuranceTypeModalState.memberId || '';

    const validRes = await memberProfileService.validMember(memberId);
    if (validRes) {
      sweetAlertService.modal({
        html: commonService.getCodeMsg(props.UICodes, CodeId.W007),
        showCancelButton: true,
        showCloseButton: true
      }).then((res) => {
        if (res.value) {
          props.setSelectInsuranceTypeModalVisible(false);

          let originUrl = RouterSettings.InsureProcess.Car;
          if (props.insTypeId === InsType.Moto) {
            originUrl = RouterSettings.InsureProcess.Moto;
          }

          const path = {
            pathname: RouterSettings.Login,
            state: { originUrl: originUrl }
          };

          props.history.push(path);
        }
      });
    } else {
      // 您尚未註冊為會員，是否註冊?
      sweetAlertService.modal({
        html: '您尚未註冊為會員，是否註冊?',
        showCancelButton: true,
        showCloseButton: true
      }).then((res) => {
        if (res.value) {
          props.setSelectInsuranceTypeModalVisible(false);
          const path = {
            pathname: RouterSettings.Signup
          };

          props.history.push(path);
        }
      });
    }
  };

  return props.flows[0] && props.flows[0].VEHICLEBCLMT ? (
    <div className="select-insurance-type-modal">
      <Modal
        visible={props.modal.selectInsuranceTypeModalState.visible}
        cancelButton={false}
        closeIcon={false}
        confirmButton={false}
        onCancel={handleClose}
      >
        <div className="select-insurance-type-modal__content">
          <div className="element__table-horizon">
            <table>
              <tbody>
                {handleCreateTbody(props.flows[0].VEHICLEBCLMT)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="select-insurance-type-modal__controls">
          <div className="select-insurance-type-modal__control-col">
            <button type="button" className="select-insurance-type-modal__btn" onClick={handleValidLogin}>我要投保</button>
          </div>
          <div className="select-insurance-type-modal__control-col">
            <button type="button" className="select-insurance-type-modal__btn" onClick={handleClose}>我要投保</button>
          </div>
        </div>
      </Modal>
    </div>
  ) : null;
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSelectInsuranceTypeModalVisible: (visible: boolean, memberId?:string, nationalityType?:string) => dispatch(setSelectInsuranceTypeModalVisibleAction(visible, memberId, nationalityType))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectInsuranceTypeModal));
